export default "__VITE_ASSET__eb435425__"